import { get, getOr, pick, omit, mapValues, values } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getViewItem as stateContext } from '.';

export const getPagination = createSelector(
  stateContext,
  get('auditLogsPagination')
);

export const getPaginationPages = createSelector(getPagination, get('pages'));

export const getPaginationWithoutPages = createSelector(
  getPagination,
  omit('pages')
);

export const getPaginationQueryOptions = createSelector(
  getPagination,
  ({ currentPage: page, limit }) => ({
    page,
    limit
  })
);

export const getPaginationLoadedPages = createSelector(
  getPaginationPages,
  mapValues(() => true)
);

export const getCurrentPageItems = createSelector(stateContext, state => {
  const page = getOr(1, 'auditLogsPagination.currentPage', state);
  const pageItemIds = get(`auditLogsPagination.pages.${page}.ids`, state);
  const pageItemsByIds = pick(pageItemIds, state.auditLogs);
  return values(pageItemsByIds);
});
